class ProxyStorage {
  getItem() {}
  setItem() {}
  removeItem() {}
  clear() {}
}
class StorageService {
  private storage: any = {};

  constructor() {
    this.storage =
      typeof window !== "undefined" ? window.localStorage : new ProxyStorage();
  }

  set(key: string, value: any) {
    if (typeof value !== "string") {
      value = JSON.stringify(value);
    }

    this.storage.setItem(key, value);
  }

  get(key: string) {
    const value = this.storage.getItem(key);

    if (!value) {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  remove(key: string) {
    this.storage.removeItem(key);
  }

  destroy() {
    this.storage.clear();
  }
}

export default new StorageService();
